class HelperService {
  formDataAppendRecursively(formData: FormData, obj: any, parentKey: string) {
    for (const key in obj) {
      const value = obj[key];
      // Determine the formatted key based on parentKey and array/object
      const formattedKey = parentKey === '' ? key : Array.isArray(obj) ? `${parentKey}[${key}]` : `${parentKey}.${key}`;

      if (value == null) continue;

      // Handle Date objects
      if (value instanceof Date) {
        formData.append(formattedKey, this.toDateTimeString(value));

        // Handle file arrays (keys starting with 'arquivo')
      } else if (obj[key].file !== undefined && key == 'arquivo') {
        const nameKey = parentKey ? `${parentKey}.${key}` : key;
        formData.append(nameKey, obj[key].file, obj[key].name);

        // Recurse into nested objects
      } else if (typeof value === 'object') {
        this.formDataAppendRecursively(formData, value, formattedKey);

        // Convert numbers (replace '.' with ',')
      } else if (typeof value === 'number') {
        formData.append(formattedKey, value.toString().replace('.', ','));

        // Append other primitive types
      } else {
        formData.append(formattedKey, String(value));
      }
    }
  }

  toDateTimeString(date: Date): string {
    const pad = (n: number) => String(n).padStart(2, '0');
    const d = `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
    const t = `${pad(date.getHours())}:${pad(date.getMinutes())}`;
    return `${d}T${t}`;
  }

  formatChavePai(chave: number): string {
    return String(chave).padStart(3, '0');
  }

  toISODateString(date: Date): string {
    const pad = (n: number) => String(n).padStart(2, '0');
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
  }

  formatDateString(data: string): string {
    if (!data) return '';
    const locale = navigator.language || 'pt-BR';
    return new Intl.DateTimeFormat(locale).format(new Date(data));
  }

  toISODateStringUTC(date: Date): string {
    const pad = (n: number) => String(n).padStart(2, '0');
    return `${date.getUTCFullYear()}-${pad(date.getUTCMonth() + 1)}-${pad(date.getUTCDate())}`;
  }

  toFormData(obj: any): FormData {
    const formData = new FormData();
    this.formDataAppendRecursively(formData, obj, '');
    return formData;
  }

  downloadBase64File(base64: string, name: string): string {
    const base64Data = base64.includes(',') ? base64.split(',')[1] : base64;
    const byteCharacters = atob(base64Data);
    const byteNumbers = Array.from(byteCharacters).map((c) => c.charCodeAt(0));
    const byteArray = new Uint8Array(byteNumbers);
    const file = new File([byteArray], name, { type: 'application/octet-stream' });
    return URL.createObjectURL(file);
  }
}

export default new HelperService();
